import { Factory, trait } from 'miragejs'

export default Factory.extend({
  name() {
    return 'Blake district'
  },
  code() {
    return 'DISTRICT_TEST_CODE'
  },

  withCoordinator: trait({
    afterCreate(district, server) {
      server.create('district-coordinator', {
        district,
      })
    },
  }),

  classlink: trait({
    usesExternalRostering: true,
    externalRosteringSource: 'classlink',
  }),
  ftp: trait({
    usesExternalRostering: true,
    externalRosteringSource: 'ftp',
  }),
})
